import TimeSlotMessage from './TimeSlotMessage'
export default TimeSlotMessage
